import { useState } from "react";
import "./Projects.css";

const STATUS_MAP = {
  Aktywny: { cls: "badge--active", label: "Active" },
  "W Rozwoju": { cls: "badge--dev", label: "In Development" },
  Ukończony: { cls: "badge--done", label: "Completed" },
  Różne: { cls: "badge--done", label: "Various" },
};

const CATEGORY_FILTERS = ["All", "Games", "Web", "Tools", "3D"];

const CAT_MAP = {
  Games: (p) => p.category === "Gry",
  Web: (p) => p.category === "Web",
  Tools: (p) => p.category === "Narzędzia",
  "3D": (p) => p.category === "Assety 3D",
};

function ProjectCard({ p }) {
  const st = STATUS_MAP[p.status] || { cls: "badge--done", label: p.status };
  const metrics = Object.entries(p.metrics || {}).slice(0, 3);

  return (
    <div className="project-card-full">
      <div className="project-card-full__top">
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--muted)" }}>
              {p.category}
            </span>
            <span className={`badge ${st.cls}`}>{st.label}</span>
          </div>
          <div className="project-card-full__title">{p.title}</div>
          <p className="project-card-full__desc">{p.description}</p>
        </div>
        {metrics.length > 0 && (
          <div className="project-metrics-row">
            {metrics.map(([key, val]) => (
              <div key={key} className="proj-metric">
                <span className="proj-metric__val">
                  {String(val).replace(/<[^>]+>/g, "")}
                </span>
                <span className="proj-metric__lbl">{key}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {p.coreFeatures && (
        <div className="project-card-full__features">
          {p.coreFeatures.map((f, i) => (
            <div key={i} className="project-card-full__feature">{f}</div>
          ))}
        </div>
      )}

      <div className="project-card-full__bottom">
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {p.technologies?.slice(0, 5).map((t) => (
            <span key={t} className="tag">{t}</span>
          ))}
        </div>
        <div className="project-card-full__actions">
          {p.link && (
            <a href={p.link} target="_blank" rel="noreferrer" className="btn btn--sm btn--primary">
              NPM →
            </a>
          )}
          {p.previewLink && (
            <a href={p.previewLink} target="_blank" rel="noreferrer" className="btn btn--sm btn--ghost">
              Demo →
            </a>
          )}
          <span style={{ fontSize: 12, color: "var(--muted)", alignSelf: "center" }}>
            {p.timeline}
          </span>
        </div>
      </div>
    </div>
  );
}

function Projects({ projects = [] }) {
  const [active, setActive] = useState("All");

  const filtered =
    active === "All"
      ? projects
      : projects.filter(CAT_MAP[active] || (() => false));

  return (
    <>
      <div className="page-hero">
        <div className="page-hero__inner">
          <div className="sec-eyebrow">Portfolio</div>
          <h1 className="page-hero__title">
            ALL
            <br />
            PROJECTS
          </h1>
          <p className="page-hero__sub">
            Games, open-source libraries, developer tools, 3D assets and web
            applications — everything built independently from scratch.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "1px",
              background: "var(--border)",
              border: "1px solid var(--border)",
              marginBottom: 2,
            }}
          >
            {[
              { val: projects.length, lbl: "Total Projects" },
              { val: projects.filter((p) => p.status === "W Rozwoju").length, lbl: "In Development" },
              { val: projects.filter((p) => p.status === "Ukończony").length, lbl: "Completed" },
              { val: projects.filter((p) => p.status === "Aktywny").length, lbl: "Active / Live" },
            ].map((s) => (
              <div key={s.lbl} style={{ background: "var(--bg2)", padding: "24px 28px" }}>
                <div style={{ fontFamily: "var(--font-d)", fontSize: "clamp(28px,3vw,44px)", color: "var(--white)", lineHeight: 1 }}>
                  {s.val}
                </div>
                <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", color: "var(--muted)", marginTop: 4 }}>
                  {s.lbl}
                </div>
              </div>
            ))}
          </div>

          <div className="filter-bar">
            {CATEGORY_FILTERS.map((f) => (
              <button
                key={f}
                className={`filter-btn${active === f ? " filter-btn--active" : ""}`}
                onClick={() => setActive(f)}
              >
                {f}
              </button>
            ))}
          </div>

          {filtered.length > 0 ? (
            <div style={{ borderLeft: "1px solid var(--border)", borderRight: "1px solid var(--border)" }}>
              {filtered.map((p) => (
                <ProjectCard key={p.id} p={p} />
              ))}
            </div>
          ) : (
            <div className="empty-state">No projects in this category yet.</div>
          )}
        </div>
      </section>
    </>
  );
}

export default Projects;
